export default __webpack_public_path__ + "static/media/gallery-placeholder-1x.739e017e.png";